import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface BudgetTargetInputProps {
  id: string;
  label: string;
  value: string;
  currency: string;
  onChange: (value: string) => void;
}

export const BudgetTargetInput = ({ id, label, value, currency, onChange }: BudgetTargetInputProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label} ({currency})</Label>
      <Input
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        type="number"
        placeholder={`Ex: ${id === 'daily-target' ? '100000' : '3000000'}`}
      />
    </div>
  );
};